import React from 'react';
import styled from 'styled-components';
import { BlueBg, HeadingText, SectionContainer } from '../common';
import GridSection from './gridSection';
import data from './data';
import breakpointsMinWidth from '../../../../../cra/src/styling/breakpointsMinWidth';
import sendMail from '../utils';
import { Button } from '../../home/shared/heroNew/shared/centerContent/components';

const Wrapper = styled.section`
  padding: 40px 0;
  @media ${breakpointsMinWidth.tabletMd} {
    padding: 50px 0;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 55px 0;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    padding: 65px 0;
  }
`;

const VideoSection = () => {
  return (
    <Wrapper>
      <BlueBg>
        <SectionContainer>
          <HeadingText>Career Advisors Love Wisedoc</HeadingText>
          <GridSection data={data} />
        </SectionContainer>
        <Button target="_blank" higherEd onClick={sendMail}>
          SCHEDULE A CALL
        </Button>
      </BlueBg>
    </Wrapper>
  );
};

export default VideoSection;
